import { createStyles, makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles((theme) =>
  createStyles({
    container: {
      display: 'flex',
      flexDirection: 'column',
      gap: '0.5rem',
      paddingInline: '0.2rem',
    },

    title: {
      '& .MuiTypography-body1': {
        color: '#8F918C',
        fontWeight: 600,
        fontSize: '1.6rem',
      },

      '& span': {
        fontWeight: 600,
        fontSize: '1.2rem',
        marginRight: '0.5rem',
        fontFamily: 'Source Sans Pro, sans-serif',
      },
    },

    card: {
      borderRadius: 4,
      height: 96,
      display: 'flex',
      flexDirection: 'column',

      '& > div:first-child': {
        flex: 1,

        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: '0 2.4rem 0',
      },

      '& .MuiTypography-body2': {
        fontWeight: 500,
        fontSize: '1.6rem',
        marginRight: '2rem',

        display: '-webkit-box',
        '-webkit-line-clamp': 2,
        '-webkit-box-orient': 'vertical',
        overflow: 'hidden',
        whiteSpace: 'normal',
        wordBreak: 'break-word',
      },

      '& .MuiIconButton-label': {
        color: '#8F918C',
      },

      '& .MuiLinearProgress-root': {
        height: '6px',
        borderRadius: '10px',

        '&.MuiLinearProgress-colorPrimary': {
          backgroundColor: 'transparent',
        },

        '& .MuiLinearProgress-bar': {
          borderRadius: '10px',
        },

        '& .MuiLinearProgress-bar1Indeterminate': {
          animationDuration: 2.3 * 1000,
        },
        '& .MuiLinearProgress-bar2Indeterminate': {
          animation: 'none',
        },

        '& .MuiLinearProgress-barColorPrimary': {
          backgroundColor: theme.palette.primary.dark,
        },
      },
    },
  }),
)
